import React, { push, Component } from "react";
import {
  Grommet,
  Box,
  Header,
  Button,
  Layer,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  Card,
  CardHeader,
  CardBody,
  List,
  Grid,
  TextInput,
  Select,
  RadioButtonGroup,
  Form,
  CheckBox,
  DateInput,
  FormField,
  CheckBoxGroup,
  Tabs,
  Tab,
  Image,
  CardFooter,
  IFrame,
} from "grommet";
import {
  Hpe,
  Close,
  More,
  Help,
  Channel,
  Notification,
  Console,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  CaretDownFill,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Filter,
  Video,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import GetHelpL1 from "./GetHelpL1";
import GetHelpL2 from "./GetHelpL2";
import GetHelpL3 from "./GetHelpL3";
import GetHelpL4 from "./GetHelpL4";
import GetHelpL5 from "./GetHelpL5";

class GetHelpLIVE extends Component {
  constructor(props) {
    super(props);
    // const { push } = React.useContext(RouterContext);

    this.state = {
      b404Issue: false,
      bCitrixrdpIssue: false,
      bICAfileIssue: false,
      bCredInDemoIssue: false,
      bLinuxMacIssue: false,
    };
    this._setHide = this._setHide.bind(this);
    this.clickb404Issue = this.clickb404Issue.bind(this);
    this.clickbCitrixIssue = this.clickbCitrixIssue.bind(this);
    this.clickbICAfileIssue = this.clickbICAfileIssue.bind(this);
    this.clickbCredInDemoIssue = this.clickbCredInDemoIssue.bind(this);
    this.clickbLinuxMacIssue = this.clickbLinuxMacIssue.bind(this);
  }
  componentDidMount() {}

  _setHide = () => {
    this.setState({
      b404Issue: false,
      bCitrixrdpIssue: false,
      bICAfileIssue: false,
      bCredInDemoIssue: false,
      bLinuxMacIssue: false,
    });
  };

  clickb404Issue = () => {
    this.setState({ b404Issue: true });
  };

  clickbCitrixIssue = () => {
    this.setState({ bCitrixrdpIssue: true });
  };

  clickbICAfileIssue = () => {
    this.setState({ bICAfileIssue: true });
  };

  clickbCredInDemoIssue = () => {
    this.setState({ bCredInDemoIssue: true });
  };

  clickbLinuxMacIssue = () => {
    this.setState({ bLinuxMacIssue: true });
  };

  render() {
    var b404 = this.state.b404Issue;
    var brdp = this.state.bCitrixrdpIssue;
    var bica = this.state.bICAfileIssue;
    var bCred = this.state.bCredInDemoIssue;
    var bmaclinux = this.state.bLinuxMacIssue;

    return (
      <Box>
        <Layer
          full={true}
          position="center"
          //height="medium"
          onClickOutside={this.props.hide}
          onEsc={this.props.hide}
        >
          <Box fill="vertical" align="stretch" justify="start">
            <Main
              overflow="auto"
              background={{ image: "url('')" }}
              flex
              align="stretch"
              justify="start"
            >
              <Box
                align="stretch"
                justify="center"
                flex="grow"
                background={{ color: "background-back" }}
                direction="row"
              >
                <Box
                  align="stretch"
                  justify="start"
                  flex="shrink"
                  pad={{ horizontal: "large", vertical: "medium" }}
                  basis="xlarge"
                  direction="column"
                  gap="medium"
                >
                  <Box align="center" justify="end" direction="row">
                    <Button
                      icon={<Close />}
                      onClick={this.props.hide}
                      secondary
                    />
                  </Box>
                  <Header
                    align="start"
                    direction="column"
                    flex={false}
                    justify="start"
                    gap="xxsmall"
                  >
                    {/*                   <Button
                    label="Back"
                    icon={<FormPrevious />}
                    onClick={() => push("/gethelp")}
                  /> */}
                    <Heading margin="none">
                      Get Help on Live demonstrations
                    </Heading>
                  </Header>
                  <Box
                    align="stretch"
                    justify="center"
                    pad="medium"
                    gap="large"
                    direction="column"
                  >
                    <Grid
                      //columns={["medium", "medium", "medium"]}
                      columns={{ size: "small", count: "fill" }}
                      rows="medium"
                      gap="medium"
                    >
                      <Card hoverIndicator onClick={this.clickb404Issue}>
                        <CardHeader
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Heading size="small">404 Error on Launch</Heading>
                        </CardHeader>
                        <CardBody pad="small">
                          <Image
                            src="/img/GetHelp/GHL1-404error.png
"
                            fit="contain"
                          />
                        </CardBody>
                        <CardFooter
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Text size="xsmall">#GH-L1</Text>
                        </CardFooter>
                      </Card>
                      <Card onClick={this.clickbCitrixIssue}>
                        <CardHeader
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Heading size="small">
                            Cannot start Citrix remote desktop
                          </Heading>
                        </CardHeader>
                        <CardBody pad="small">
                          <Image
                            src="/img/GetHelp/GHL2-vmlaunch.png"
                            fit="contain"
                          />
                        </CardBody>
                        <CardFooter
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Text size="xsmall">#GH-L2</Text>
                        </CardFooter>
                      </Card>
                      <Card onClick={this.clickbICAfileIssue}>
                        <CardHeader
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Heading size="small">Cannot open .ica file</Heading>
                        </CardHeader>
                        <CardBody pad="small">
                          <Image
                            src="/img/GetHelp/GHL3-icaOpenIssue.png"
                            fit="contain"
                          />
                        </CardBody>
                        <CardFooter
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Text size="xsmall">#GH-L3</Text>
                        </CardFooter>
                      </Card>
                      <Card onClick={this.clickbCredInDemoIssue}>
                        <CardHeader
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Heading size="small">
                            Issues with credentials within a demo
                          </Heading>
                        </CardHeader>
                        <CardBody pad="small">
                          <Image
                            src="/img/GetHelp/GHL4-Credential.png


"
                            fit="contain"
                          />
                        </CardBody>
                        <CardFooter
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Text size="xsmall">#GH-L4</Text>
                        </CardFooter>
                      </Card>
                      <Card onClick={this.clickbLinuxMacIssue}>
                        <CardHeader
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Heading size="small">
                            Issues when using Linux or Apple devices
                          </Heading>
                        </CardHeader>
                        <CardBody pad="small">
                          <Image
                            src="/img/GetHelp/GHL5-DE2.png
"
                            fit="contain"
                          />
                        </CardBody>
                        <CardFooter
                          align="center"
                          direction="row"
                          flex={false}
                          justify="between"
                          gap="medium"
                          pad="small"
                        >
                          <Text size="xsmall">#GH-L5</Text>
                        </CardFooter>
                      </Card>
                    </Grid>
                  </Box>
                </Box>
              </Box>
            </Main>
          </Box>
        </Layer>
        {b404 && <GetHelpL1 disp={b404} hide={this._setHide} />}
        {brdp && <GetHelpL2 disp={brdp} hide={this._setHide} />}
        {bica && <GetHelpL3 disp={bica} hide={this._setHide} />}
        {bCred && <GetHelpL4 disp={bCred} hide={this._setHide} />}
        {bmaclinux && <GetHelpL5 disp={bmaclinux} hide={this._setHide} />}
      </Box>
    );
  }
}
export default GetHelpLIVE;
